/******************************************************************************
 * Memokid: A game to train one's memory                                      *
 * Copyright (C) 2022 Lukas Laag                                              *
 * This file is part of Memokid                                               *
 *                                                                            *
 * Memokid is free software: you can redistribute it and/or modify            *
 * it under the terms of the GNU General Public License as published by       *
 * the Free Software Foundation, either version 3 of the License, or          *
 * (at your option) any later version.                                        *
 *                                                                            *
 * Memokid is distributed in the hope that it will be useful,                 *
 * but WITHOUT ANY WARRANTY; without even the implied warranty of             *
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the              *
 * GNU General Public License for more details.                               *
 *                                                                            *
 * You should have received a copy of the GNU General Public License          *
 * along with Memokid.  If not, see <https://www.gnu.org/licenses/>.          *
 *                                                                            *
 ******************************************************************************/

import { useIntl } from 'react-intl'
import Button from '@mui/material/Button'
import HomeIcon from '@mui/icons-material/Home'
import { connect } from 'react-redux'
import { go, routes } from '../location'
import moment from 'moment'
import Card from '../components/Card'
import { ensureLoaded } from '../actions/game'
import { LEVELS, log } from '../logs'

const ScoresScreen = props => {
  log('ScoresScreen', LEVELS.INFO, props)
  const { decks, scores, settings: { deckRefid }, dispatch } = props
  const intl = useIntl()
  const deck = ensureLoaded(decks[deckRefid], dispatch)
  const cards = deck.cards
  return (
    <div className='game-history'>
      <p style={{ paddingTop: '20px', paddingBottom: '20px', fontWeight: 600 }}>{intl.formatMessage({ id: 'scores.title' })}</p>
      <div style={{ overflowY: 'auto', width: '100%' }}>
        {
          (scores.length === 0)
            ? <p style={{ textAlign: 'center' }}>{intl.formatMessage({ id: 'scores.noscores' })}</p>
            : <table style={{ border: '1px solid black', width: 'calc(100% - 40px)', marginLeft: '20px' }}>
              <thead>
                <tr>
                  <th />
                  <th>{intl.formatMessage({ id: 'scores.when' })}</th>
                  <th>{intl.formatMessage({ id: 'scores.players' })}</th>
                  <th>{intl.formatMessage({ id: 'scores.scores' })}</th>
                </tr>
              </thead>
              <tbody>
                {
                  scores.map(({ date, players, scores }, index) =>
                    <tr key={index}>
                      <td>
                        <div className='game-history-card'>
                          <Card
                            image={cards[index % cards.length].image}
                            transform={{}}
                            flipped
                            size={100}
                          />
                        </div>
                      </td>
                      <td>
                        {moment(date).format('dddd, MMMM Do YYYY, h:mm:ss a')}
                      </td>
                      <td>
                        {
                          players.reduce((acc, player, index) => {
                            if (index > 0) {
                              acc.push(<span key={2 * index - 1}> {intl.formatMessage({ id: 'scores.vs' })} </span>)
                            }
                            const className = (scores[index] === Math.max(...scores)) ? 'game-winner' : ''
                            acc.push(<span className={className} key={2 * index}>{player}</span>)
                            return acc
                          }, [])
                        }
                      </td>
                      <td>
                        {
                          scores.reduce((acc, score, index) => {
                            if (index > 0) {
                              acc.push(<span key={2 * index - 1}> {intl.formatMessage({ id: 'scores.to' })} </span>)
                            }
                            const className = (score === Math.max(...scores)) ? 'game-winner' : ''
                            acc.push(<span className={className} key={2 * index}>{score}</span>)
                            return acc
                          }, [])
                        }
                      </td>
                    </tr>)
                }
              </tbody>
            </table>
        }
      </div>
      <div style={{ paddingTop: '20px', paddingBottom: '20px', width: '100%', textAlign: 'center' }}>
        <Button
          variant='contained'
          startIcon={<HomeIcon />}
          onClick={() => dispatch(go(routes.HOME))}
        >{intl.formatMessage({ id: 'common.home' })}
        </Button>
      </div>
    </div>
  )
}
ScoresScreen.displayName = 'ScoresScreen'

const mapStateToProps = ({ decks, scores, settings }) => ({ decks, scores, settings })
export default connect(mapStateToProps)(ScoresScreen)
